import React from "react";

const AppDevelopImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 773.616 528.694">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_6147"
            data-name="Rectangle 6147"
            width="68.024"
            height="74.748"
            fill="#a2abfc"
          />
        </clipPath>
      </defs>
      <g
        id="Group_8017"
        data-name="Group 8017"
        transform="translate(-694.754 -159.72)"
      >
        <g
          id="Group_15809"
          data-name="Group 15809"
          transform="translate(590.057 197.962)"
        >
          <g
            id="Group_15756"
            data-name="Group 15756"
            transform="translate(118.232 9.182)"
          >
            <g
              id="Group_15749"
              data-name="Group 15749"
              transform="translate(66.323 43.759)"
            >
              <path
                id="Path_27202"
                data-name="Path 27202"
                d="M299.024,180.335V166.5a2.449,2.449,0,0,0-2.45-2.45h-3.561a2.247,2.247,0,0,1-2.2-1.725,48.946,48.946,0,0,0-6.164-14.959,2.284,2.284,0,0,1,.3-2.832l2.5-2.5a2.452,2.452,0,0,0,0-3.467l-9.783-9.783a2.45,2.45,0,0,0-3.465,0l-2.5,2.5a2.282,2.282,0,0,1-2.832.3,48.991,48.991,0,0,0-14.963-6.171,2.246,2.246,0,0,1-1.724-2.2v-3.55a2.451,2.451,0,0,0-2.451-2.451H235.9a2.451,2.451,0,0,0-2.451,2.451v3.549a2.247,2.247,0,0,1-1.725,2.2,48.961,48.961,0,0,0-14.964,6.169,2.282,2.282,0,0,1-2.832-.3l-2.5-2.5a2.45,2.45,0,0,0-3.465,0l-9.783,9.783a2.452,2.452,0,0,0,0,3.467l2.5,2.5a2.28,2.28,0,0,1,.3,2.831,49.04,49.04,0,0,0-6.165,14.963,2.246,2.246,0,0,1-2.2,1.725h-3.557a2.45,2.45,0,0,0-2.451,2.45v13.837a2.451,2.451,0,0,0,2.451,2.45h3.558a2.247,2.247,0,0,1,2.2,1.724,49.011,49.011,0,0,0,6.166,14.959,2.282,2.282,0,0,1-.3,2.832l-2.5,2.505a2.45,2.45,0,0,0,0,3.465l9.783,9.784a2.45,2.45,0,0,0,3.465,0l2.507-2.508a2.283,2.283,0,0,1,2.832-.3,48.994,48.994,0,0,0,14.956,6.158,2.247,2.247,0,0,1,1.725,2.2v3.568a2.451,2.451,0,0,0,2.451,2.451h13.835a2.451,2.451,0,0,0,2.451-2.451v-3.569a2.248,2.248,0,0,1,1.725-2.2,48.982,48.982,0,0,0,14.955-6.158,2.281,2.281,0,0,1,2.831.3l2.51,2.509a2.45,2.45,0,0,0,3.465,0l9.783-9.784a2.45,2.45,0,0,0,0-3.465l-2.507-2.507a2.283,2.283,0,0,1-.3-2.832,48.938,48.938,0,0,0,6.165-14.956,2.247,2.247,0,0,1,2.2-1.725h3.564A2.45,2.45,0,0,0,299.024,180.335Zm-56.213,32.093A39.007,39.007,0,1,1,281.8,173.4,39,39,0,0,1,242.811,212.429Z"
                transform="translate(-186.604 -117.207)"
                fill="none"
                stroke="#dee3fc"
                strokeMiterlimit="10"
                strokeWidth="0.79"
              />
              <path
                id="Path_27203"
                data-name="Path 27203"
                d="M336.884,209.819V200.39a1.67,1.67,0,0,0-1.67-1.67h-2.427a1.531,1.531,0,0,1-1.5-1.176,33.375,33.375,0,0,0-4.2-10.193,1.554,1.554,0,0,1,.2-1.93L329,183.714a1.671,1.671,0,0,0,0-2.362l-6.667-6.667a1.669,1.669,0,0,0-2.361,0l-1.7,1.7a1.558,1.558,0,0,1-1.93.2,33.354,33.354,0,0,0-10.2-4.2,1.533,1.533,0,0,1-1.176-1.5v-2.419a1.669,1.669,0,0,0-1.67-1.67h-9.429a1.669,1.669,0,0,0-1.67,1.67v2.419a1.533,1.533,0,0,1-1.176,1.5,33.385,33.385,0,0,0-10.2,4.2,1.557,1.557,0,0,1-1.93-.2l-1.7-1.7a1.67,1.67,0,0,0-2.362,0l-6.666,6.667a1.671,1.671,0,0,0,0,2.362l1.7,1.7a1.555,1.555,0,0,1,.2,1.929,33.369,33.369,0,0,0-4.2,10.2,1.531,1.531,0,0,1-1.5,1.174h-2.425a1.67,1.67,0,0,0-1.67,1.67v9.429a1.67,1.67,0,0,0,1.67,1.671h2.426a1.53,1.53,0,0,1,1.5,1.174,33.426,33.426,0,0,0,4.2,10.195,1.554,1.554,0,0,1-.2,1.93l-1.706,1.706a1.671,1.671,0,0,0,0,2.362l6.666,6.667a1.671,1.671,0,0,0,2.362,0l1.709-1.709a1.554,1.554,0,0,1,1.929-.2,33.411,33.411,0,0,0,10.193,4.2,1.531,1.531,0,0,1,1.176,1.5v2.433a1.67,1.67,0,0,0,1.67,1.67h9.429a1.67,1.67,0,0,0,1.67-1.67v-2.434a1.53,1.53,0,0,1,1.176-1.5,33.418,33.418,0,0,0,10.192-4.2,1.555,1.555,0,0,1,1.929.2l1.71,1.71a1.67,1.67,0,0,0,2.361,0L329,228.858a1.671,1.671,0,0,0,0-2.362l-1.709-1.708a1.558,1.558,0,0,1-.2-1.93,33.384,33.384,0,0,0,4.2-10.193,1.531,1.531,0,0,1,1.5-1.174h2.428A1.67,1.67,0,0,0,336.884,209.819Zm-38.308,20.373A25.084,25.084,0,1,1,323.648,205.1,25.079,25.079,0,0,1,298.575,230.192Z"
                transform="translate(-160.825 -99.853)"
                fill="#dee3fc"
              />
            </g>
            <g
              id="Group_15750"
              data-name="Group 15750"
              transform="translate(13.564)"
            >
              <circle
                id="Ellipse_1547"
                data-name="Ellipse 1547"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(46.684 394.252)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1548"
                data-name="Ellipse 1548"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(659.057 269.353)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1549"
                data-name="Ellipse 1549"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(649.915 106.134)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1550"
                data-name="Ellipse 1550"
                cx="2.867"
                cy="2.867"
                r="2.867"
                transform="translate(487.272 52.361)"
                fill="#a4afff"
              />
              <path
                id="Path_27204"
                data-name="Path 27204"
                d="M200.233,98.153a2.867,2.867,0,1,1-2.867-2.867A2.867,2.867,0,0,1,200.233,98.153Z"
                transform="translate(-131.083 -81.119)"
                fill="#a4afff"
              />
              <path
                id="Path_27205"
                data-name="Path 27205"
                d="M247.243,228.949a2.867,2.867,0,1,1-2.867-2.867A2.867,2.867,0,0,1,247.243,228.949Z"
                transform="translate(-114.633 -35.349)"
                fill="#a4afff"
              />
              <path
                id="Path_27206"
                data-name="Path 27206"
                d="M169.322,384.358a2.867,2.867,0,1,1-2.867-2.866A2.866,2.866,0,0,1,169.322,384.358Z"
                transform="translate(-141.9 19.035)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1551"
                data-name="Ellipse 1551"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(592.004 396.952)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1552"
                data-name="Ellipse 1552"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(689.2 396.952)"
                fill="#a4afff"
              />
              <circle
                id="Ellipse_1553"
                data-name="Ellipse 1553"
                cx="4.571"
                cy="4.571"
                r="4.571"
                transform="translate(143.385)"
                fill="#a4afff"
              />
              <path
                id="Path_27207"
                data-name="Path 27207"
                d="M493.921,243.822a6.116,6.116,0,1,1-6.117-6.117A6.116,6.116,0,0,1,493.921,243.822Z"
                transform="translate(-30.585 -31.282)"
                fill="#a4afff"
              />
              <path
                id="Path_27208"
                data-name="Path 27208"
                d="M159.754,187.8a6.116,6.116,0,1,1-6.115-6.115A6.116,6.116,0,0,1,159.754,187.8Z"
                transform="translate(-147.522 -50.887)"
                fill="#a4afff"
              />
            </g>
            <g
              id="Group_15751"
              data-name="Group 15751"
              transform="translate(0 36.128)"
            >
              <rect
                id="Rectangle_6105"
                data-name="Rectangle 6105"
                width="9.484"
                height="9.484"
                rx="0.664"
                fill="#fff"
              />
              <rect
                id="Rectangle_6106"
                data-name="Rectangle 6106"
                width="9.484"
                height="9.484"
                rx="0.664"
                transform="translate(12.687)"
                fill="#fff"
              />
              <rect
                id="Rectangle_6107"
                data-name="Rectangle 6107"
                width="9.484"
                height="9.484"
                rx="0.664"
                transform="translate(25.373)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_15753"
              data-name="Group 15753"
              transform="translate(646.051 369.202)"
            >
              <g id="Group_15752" data-name="Group 15752">
                <rect
                  id="Rectangle_6108"
                  data-name="Rectangle 6108"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  fill="#dee3fc"
                />
                <rect
                  id="Rectangle_6109"
                  data-name="Rectangle 6109"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  transform="translate(12.687)"
                  fill="#dee3fc"
                />
                <rect
                  id="Rectangle_6110"
                  data-name="Rectangle 6110"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  transform="translate(25.373)"
                  fill="#dee3fc"
                />
              </g>
            </g>
            <g
              id="Group_15755"
              data-name="Group 15755"
              transform="translate(59.55 364.004)"
            >
              <g id="Group_15754" data-name="Group 15754">
                <rect
                  id="Rectangle_6111"
                  data-name="Rectangle 6111"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  fill="#dee3fc"
                />
                <rect
                  id="Rectangle_6112"
                  data-name="Rectangle 6112"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  transform="translate(12.687)"
                  fill="#dee3fc"
                />
                <rect
                  id="Rectangle_6113"
                  data-name="Rectangle 6113"
                  width="9.484"
                  height="9.484"
                  rx="0.664"
                  transform="translate(25.373)"
                  fill="#dee3fc"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_15765"
            data-name="Group 15765"
            transform="translate(318.733 0)"
          >
            <g id="Group_15757" data-name="Group 15757">
              <rect
                id="Rectangle_6114"
                data-name="Rectangle 6114"
                width="240.289"
                height="464.189"
                rx="21.349"
                fill="#3945ba"
              />
              <rect
                id="Rectangle_6115"
                data-name="Rectangle 6115"
                width="231.29"
                height="453.527"
                rx="18.7"
                transform="translate(4.499 4.064)"
                fill="#fff"
              />
              <path
                id="Path_27209"
                data-name="Path 27209"
                d="M507.874,103.546V506.117a17.1,17.1,0,0,1-17.1,17.1H313.929a17.1,17.1,0,0,1-17.1-17.1V103.546a17.1,17.1,0,0,1,17.1-17.1h29.491a4.324,4.324,0,0,1,3.866,2.388l3.132,6.252a8.447,8.447,0,0,0,7.576,4.691h88.721a8.447,8.447,0,0,0,7.576-4.691l3.132-6.252a4.324,4.324,0,0,1,3.866-2.388h29.491A17.1,17.1,0,0,1,507.874,103.546Z"
                transform="translate(-282.209 -75.029)"
                fill="#dee3fc"
              />
              <path
                id="Path_27210"
                data-name="Path 27210"
                d="M421.884,92.467H350.427a3.008,3.008,0,0,1-3.008-3.009h0a3.008,3.008,0,0,1,3.008-3.009h71.457a3.009,3.009,0,0,1,3.009,3.009h0A3.009,3.009,0,0,1,421.884,92.467Z"
                transform="translate(-264.507 -75.029)"
                fill="#dee3fc"
              />
            </g>
            <rect
              id="Rectangle_6116"
              data-name="Rectangle 6116"
              width="181.634"
              height="78.77"
              rx="8.379"
              transform="translate(27.269 355.441)"
              fill="none"
              stroke="#698bd1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              strokeDasharray="2.837"
            />
            <rect
              id="Rectangle_6117"
              data-name="Rectangle 6117"
              width="95.198"
              height="55.304"
              rx="6.044"
              transform="translate(102.493 185.615)"
              fill="none"
              stroke="#698bd1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              strokeDasharray="2.837"
            />
            <g
              id="Group_15761"
              data-name="Group 15761"
              transform="translate(27.269 247.053)"
            >
              <rect
                id="Rectangle_6118"
                data-name="Rectangle 6118"
                width="182.355"
                height="88.155"
                rx="7.201"
                transform="translate(6.612 7.132)"
                fill="#4b5a9b"
              />
              <path
                id="Path_27211"
                data-name="Path 27211"
                d="M487.834,270.706v68.752a9.7,9.7,0,0,1-9.706,9.693H315.906a9.7,9.7,0,0,1-9.706-9.693V270.706A9.708,9.708,0,0,1,315.906,261H478.128A9.708,9.708,0,0,1,487.834,270.706Z"
                transform="translate(-306.2 -261)"
                fill="#7f95f4"
              />
              <rect
                id="Rectangle_6119"
                data-name="Rectangle 6119"
                width="60.915"
                height="60.915"
                rx="4.861"
                transform="translate(8.392 20.072)"
                fill="#fff"
              />
              <g
                id="Group_15758"
                data-name="Group 15758"
                transform="translate(75.224 23.635)"
              >
                <path
                  id="Path_27212"
                  data-name="Path 27212"
                  d="M406.086,282.652H364a2.072,2.072,0,0,1-2.072-2.072h0A2.072,2.072,0,0,1,364,278.508h42.09a2.073,2.073,0,0,1,2.073,2.072h0A2.073,2.073,0,0,1,406.086,282.652Z"
                  transform="translate(-361.924 -278.508)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27213"
                  data-name="Path 27213"
                  d="M386.906,288.783H364a2.073,2.073,0,0,1-2.072-2.072h0A2.073,2.073,0,0,1,364,284.637h22.91a2.073,2.073,0,0,1,2.072,2.074h0A2.073,2.073,0,0,1,386.906,288.783Z"
                  transform="translate(-361.924 -276.363)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27214"
                  data-name="Path 27214"
                  d="M449.2,288.783H387.213a2.073,2.073,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.074H449.2a2.074,2.074,0,0,1,2.072,2.074h0A2.074,2.074,0,0,1,449.2,288.783Z"
                  transform="translate(-353.799 -276.363)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27215"
                  data-name="Path 27215"
                  d="M399.443,294.911H364a2.073,2.073,0,0,1-2.072-2.072h0A2.072,2.072,0,0,1,364,290.767h35.447a2.073,2.073,0,0,1,2.072,2.072h0A2.074,2.074,0,0,1,399.443,294.911Z"
                  transform="translate(-361.924 -274.218)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27216"
                  data-name="Path 27216"
                  d="M418.319,294.911H396.035a2.073,2.073,0,0,1-2.072-2.072h0a2.072,2.072,0,0,1,2.072-2.072h22.283a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,418.319,294.911Z"
                  transform="translate(-350.712 -274.218)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27217"
                  data-name="Path 27217"
                  d="M438.455,294.911H417.933a2.073,2.073,0,0,1-2.072-2.072h0a2.072,2.072,0,0,1,2.072-2.072h20.522a2.073,2.073,0,0,1,2.072,2.072h0A2.074,2.074,0,0,1,438.455,294.911Z"
                  transform="translate(-343.05 -274.218)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27218"
                  data-name="Path 27218"
                  d="M457.329,301.04H364a2.072,2.072,0,0,1-2.072-2.072h0A2.072,2.072,0,0,1,364,296.9h93.333a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,457.329,301.04Z"
                  transform="translate(-361.924 -272.073)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27219"
                  data-name="Path 27219"
                  d="M415.364,307.169H364a2.072,2.072,0,0,1-2.072-2.072h0A2.072,2.072,0,0,1,364,303.025h51.368a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,415.364,307.169Z"
                  transform="translate(-361.924 -269.929)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27220"
                  data-name="Path 27220"
                  d="M441.867,307.169H408.182a2.073,2.073,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.072h33.685a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,441.867,307.169Z"
                  transform="translate(-346.462 -269.929)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27221"
                  data-name="Path 27221"
                  d="M394.177,313.3H364a2.072,2.072,0,0,1-2.072-2.072h0A2.073,2.073,0,0,1,364,309.154h30.18a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,394.177,313.3Z"
                  transform="translate(-361.924 -267.784)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27222"
                  data-name="Path 27222"
                  d="M422.585,313.3H392.4a2.072,2.072,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.072h30.18a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,422.585,313.3Z"
                  transform="translate(-351.983 -267.784)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27223"
                  data-name="Path 27223"
                  d="M437.675,313.3H420.162a2.072,2.072,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.072h17.513a2.074,2.074,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,437.675,313.3Z"
                  transform="translate(-342.27 -267.784)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27224"
                  data-name="Path 27224"
                  d="M406.086,319.429H364a2.073,2.073,0,0,1-2.072-2.074h0A2.073,2.073,0,0,1,364,315.283h42.09a2.074,2.074,0,0,1,2.073,2.072h0A2.074,2.074,0,0,1,406.086,319.429Z"
                  transform="translate(-361.924 -265.639)"
                  fill="#b2c1f9"
                />
                <path
                  id="Path_27225"
                  data-name="Path 27225"
                  d="M444.046,282.652H401.955a2.072,2.072,0,0,1-2.072-2.072h0a2.072,2.072,0,0,1,2.072-2.072h42.091a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,444.046,282.652Z"
                  transform="translate(-348.641 -278.508)"
                  fill="#b2c1f9"
                />
              </g>
              <g id="Group_15760" data-name="Group 15760">
                <path
                  id="Path_27226"
                  data-name="Path 27226"
                  d="M487.834,270.706v2.889H306.2v-2.889A9.708,9.708,0,0,1,315.906,261H478.128A9.708,9.708,0,0,1,487.834,270.706Z"
                  transform="translate(-306.2 -261)"
                  fill="#3052ce"
                />
                <g
                  id="Group_15759"
                  data-name="Group 15759"
                  transform="translate(142.897 4.275)"
                >
                  <path
                    id="Path_27227"
                    data-name="Path 27227"
                    d="M416.556,266.416a2.25,2.25,0,1,1-2.25-2.249A2.251,2.251,0,0,1,416.556,266.416Z"
                    transform="translate(-412.055 -264.167)"
                    fill="#dee3fc"
                  />
                  <path
                    id="Path_27228"
                    data-name="Path 27228"
                    d="M425.084,266.416a2.25,2.25,0,1,1-2.25-2.249A2.251,2.251,0,0,1,425.084,266.416Z"
                    transform="translate(-409.071 -264.167)"
                    fill="#dee3fc"
                  />
                  <path
                    id="Path_27229"
                    data-name="Path 27229"
                    d="M433.612,266.416a2.25,2.25,0,1,1-2.25-2.249A2.251,2.251,0,0,1,433.612,266.416Z"
                    transform="translate(-406.086 -264.167)"
                    fill="#dee3fc"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_15763"
              data-name="Group 15763"
              transform="translate(37.902 185.665)"
            >
              <rect
                id="Rectangle_6120"
                data-name="Rectangle 6120"
                width="55.254"
                height="55.254"
                rx="7.151"
                fill="none"
                stroke="#495ad6"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <g
                id="Group_15762"
                data-name="Group 15762"
                transform="translate(11.047 19.635)"
              >
                <path
                  id="Path_27230"
                  data-name="Path 27230"
                  d="M330.221,230.071l-7.961,7.961,8.023,8.023"
                  transform="translate(-322.26 -230.071)"
                  fill="none"
                  stroke="#495ad6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.672"
                />
                <path
                  id="Path_27231"
                  data-name="Path 27231"
                  d="M340.943,230.071l7.961,7.961-8.023,8.023"
                  transform="translate(-315.745 -230.071)"
                  fill="none"
                  stroke="#495ad6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.672"
                />
                <line
                  id="Line_188"
                  data-name="Line 188"
                  x1="7.455"
                  y2="15.984"
                  transform="translate(12.852)"
                  fill="none"
                  stroke="#495ad6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.672"
                />
              </g>
            </g>
            <g
              id="Group_15764"
              data-name="Group 15764"
              transform="translate(27.269 39.757)"
            >
              <rect
                id="Rectangle_6121"
                data-name="Rectangle 6121"
                width="181.634"
                height="134.494"
                rx="8.18"
                fill="#b2c1f9"
              />
              <circle
                id="Ellipse_1554"
                data-name="Ellipse 1554"
                cx="26.324"
                cy="26.324"
                r="26.324"
                transform="translate(118.524 9.193)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27232"
                data-name="Path 27232"
                d="M412.966,234.067H317.242A11.047,11.047,0,0,1,306.2,223.024v-17.7l41.889-72.559a5.689,5.689,0,0,1,9.854,0l31.629,54.78,23.489,40.687A5.582,5.582,0,0,1,412.966,234.067Z"
                transform="translate(-306.2 -99.573)"
                fill="#fff"
              />
              <path
                id="Path_27233"
                data-name="Path 27233"
                d="M439.6,226.291H348.06l26.864-46.519L389.4,154.7a5.119,5.119,0,0,1,8.869,0Z"
                transform="translate(-291.552 -91.797)"
                fill="#f0f4ff"
              />
            </g>
          </g>
          <g
            id="Group_15775"
            data-name="Group 15775"
            transform="translate(528.661 180.566)"
          >
            <g
              id="Group_15767"
              data-name="Group 15767"
              transform="translate(76.383 202.56)"
            >
              <rect
                id="Rectangle_6122"
                data-name="Rectangle 6122"
                width="70.57"
                height="106.055"
                fill="#3b47bc"
              />
              <rect
                id="Rectangle_6123"
                data-name="Rectangle 6123"
                width="27.021"
                height="106.055"
                transform="translate(97.591 106.055) rotate(180)"
                fill="#495ad6"
              />
              <g
                id="Group_15766"
                data-name="Group 15766"
                transform="translate(74.438 4.073)"
              >
                <rect
                  id="Rectangle_6124"
                  data-name="Rectangle 6124"
                  width="19.839"
                  height="3.385"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6125"
                  data-name="Rectangle 6125"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 7.271)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6126"
                  data-name="Rectangle 6126"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 14.542)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6127"
                  data-name="Rectangle 6127"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 21.813)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6128"
                  data-name="Rectangle 6128"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 29.085)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6129"
                  data-name="Rectangle 6129"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 36.356)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6130"
                  data-name="Rectangle 6130"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 43.627)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6131"
                  data-name="Rectangle 6131"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 50.898)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6132"
                  data-name="Rectangle 6132"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 58.169)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6133"
                  data-name="Rectangle 6133"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 65.44)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6134"
                  data-name="Rectangle 6134"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 72.711)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6135"
                  data-name="Rectangle 6135"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 79.982)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6136"
                  data-name="Rectangle 6136"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 87.253)"
                  fill="#b2c1f9"
                />
                <rect
                  id="Rectangle_6137"
                  data-name="Rectangle 6137"
                  width="19.839"
                  height="3.385"
                  transform="translate(0 94.524)"
                  fill="#b2c1f9"
                />
              </g>
            </g>
            <g
              id="Group_15774"
              data-name="Group 15774"
              transform="translate(0 0)"
            >
              <path
                id="Path_27234"
                data-name="Path 27234"
                d="M489.612,444.07h35.865s2-6.387-2.34-14.3c0,0-2.886,2.315-11.534.749a38.454,38.454,0,0,1-6.1,4.263C503,435.994,488.646,438.813,489.612,444.07Z"
                transform="translate(-424.693 -135.455)"
                fill="#281616"
              />
              <path
                id="Path_27235"
                data-name="Path 27235"
                d="M491.665,367.333c2.316,13.822,13.005,60.585,17.6,88.21,8.4.715,12.432-.248,14.569-.741-.419-9.633-1.247-32.675-1.15-42.781.159-17.078.961-39.6-6.557-51.958l-25.279,1.99c.154,1.334.294,2.42.417,3.2C491.387,365.994,491.526,366.681,491.665,367.333Z"
                transform="translate(-424.244 -159.848)"
                fill="#002c54"
              />
              <path
                id="Path_27236"
                data-name="Path 27236"
                d="M441.556,444.07h35.866s2-6.387-2.339-14.3c0,0-2.888,2.315-11.534.749a38.495,38.495,0,0,1-6.1,4.263C454.942,435.994,440.59,438.813,441.556,444.07Z"
                transform="translate(-441.51 -135.455)"
                fill="#281616"
              />
              <path
                id="Path_27237"
                data-name="Path 27237"
                d="M457.066,456.89a41.148,41.148,0,0,0,14.168,1.268c1.907-11.1,4.919-35.537,7.63-46.989,4.206-17.8,8.324-42.283,5.463-51.017l-24.866-6.245C459.377,354.694,457.354,429.618,457.066,456.89Z"
                transform="translate(-436.066 -162.002)"
                fill="#052635"
              />
              <path
                id="Path_27238"
                data-name="Path 27238"
                d="M555.428,337.229h0c-.5-4.914-1.074-8.5-1.074-8.5l-27.782,6.8-23.6,5.377c-8.749,1.949-19.318,4.3-28.636,6.4-10.455,2.376-17.4,10.318-15.106,20.788l2.62,12.7c14.624-.2,83.379-6.79,89.259-9.76C557.755,367.674,559.755,355.811,555.428,337.229Z"
                transform="translate(-435.462 -170.814)"
                fill="#052635"
              />
              <path
                id="Path_27239"
                data-name="Path 27239"
                d="M586.151,337.666h0a38.388,38.388,0,0,0-2.9-10.187l-25.961,8.483-23.6,5.377c-8.749,1.949-19.319,4.3-28.636,6.4-10.455,2.376-17.4,10.318-15.107,20.788l2.621,12.7c14.623-.2,75.745-2.33,89.259-9.76C588.355,367.88,590.477,356.247,586.151,337.666Z"
                transform="translate(-424.711 -171.25)"
                fill="#002c54"
              />
              <g
                id="Group_15768"
                data-name="Group 15768"
                transform="translate(42.838 124.127)"
              >
                <path
                  id="Path_27240"
                  data-name="Path 27240"
                  d="M514.084,306.171s12.34-5.574,15.735.016c1.859,3.06.574,8.745-3.635,11.132s-27.99,12.445-50.437,18.054a54.476,54.476,0,0,0-2.5-6.4,118.18,118.18,0,0,0,20.08-11.207,128.007,128.007,0,0,1,20.761-11.591Z"
                  transform="translate(-473.243 -303.698)"
                  fill="#e5918f"
                />
              </g>
              <path
                id="Path_27241"
                data-name="Path 27241"
                d="M508.524,276.985l-10.576,42.241s1.092,10.678,11.877,5.437,17.932-38.894,17.932-38.894Z"
                transform="translate(-421.76 -188.92)"
                fill="#e5918f"
              />
              <path
                id="Path_27242"
                data-name="Path 27242"
                d="M524.936,306.914c-1.308-.316-2.557-.663-3.761-1.023q-1.851-.543-3.521-1.129c-10.049-3.445-15.48-7.583-15.48-7.583,3.159-13.734,6.966-22.956,10.35-29.034a4.3,4.3,0,0,0,.256-.451l.27-.451a26.412,26.412,0,0,1,7.357-7.657c.3-.211.586-.406.887-.617l1.249,22.054.211,2.271Z"
                transform="translate(-420.28 -195.224)"
                fill="#fff"
              />
              <path
                id="Path_27243"
                data-name="Path 27243"
                d="M520.924,301.315c-1.308-.316-2.557-.663-3.761-1.023q-1.851-.543-3.521-1.129c2.11-14.856,4.017-24.191,4.017-24.191l1.083,2.723Z"
                transform="translate(-416.268 -189.624)"
                fill="#c7e5f2"
              />
              <path
                id="Path_27244"
                data-name="Path 27244"
                d="M583.3,270.934c-.256,6.528-1.4,17.015-2.392,27.544-.316,3.34-.617,6.694-.873,9.929-.18,2.015-3.218,12.773-3.34,14.7-.541,9.207-5.054,16.1-.782,30.117a22.07,22.07,0,0,1,1.278,6.469c0,.962-1.249,1.971-1.744,2.242-1.791,1.038-5.311,1.759-9.583,2.287h-.015a248.612,248.612,0,0,1-26.6,1.218c-9.192,0-22.987-1.459-24.732-3.776-1.594-2.121-.12-5.205.632-9.463,3.386-19.211,2.181-29.229,1.971-43.1,0-.346-.015-.693-.015-1.053-.346-21.392-1.76-39.7-.767-46.3.3-.211.586-.406.887-.617,1.459-.993,2.889-1.88,4.273-2.663.12-.059.271-.15.421-.24.421-.24.857-.466,1.264-.693a4.889,4.889,0,0,1,.482-.24,104.885,104.885,0,0,1,10.259-4.047c.331-.105.632-.211.888-.286,2.451-.15,5.114-.18,7.987-.1,2.5.074,6.319.4,10.47.948h.015a108.187,108.187,0,0,1,13.9,2.6s.046.016.076.031c.767.24,5.747,2.106,10.937,7.657A37.054,37.054,0,0,1,583.3,270.934Z"
                transform="translate(-416.211 -197.379)"
                fill="#fff"
              />
              <path
                id="Path_27245"
                data-name="Path 27245"
                d="M562.932,344.87a22.07,22.07,0,0,1,1.278,6.469c0,.963-1.249,1.971-1.744,2.242-1.791,1.038-5.31,1.759-9.583,2.287,1.76-.212,4.8-3,4.8-5.521,0-1.764-2.287-13.675-1.655-21.363.632-7.672,1.88-19.887-.5-29.666s-4.633-22.641-4.633-22.641l13.4,8.094s1.731,2.422,3.626,5.355c-.316,3.34-.617,6.694-.873,9.929C566.873,302.071,558.659,330.85,562.932,344.87Z"
                transform="translate(-403.231 -189.028)"
                fill="#c7e5f2"
              />
              <g
                id="Group_15772"
                data-name="Group 15772"
                transform="translate(94.436)"
              >
                <path
                  id="Path_27246"
                  data-name="Path 27246"
                  d="M516.13,224.354s1.16,14.019,5.807,14.961,3.507-5.015,3.507-5.015l-.649-6.657Z"
                  transform="translate(-509.833 -207.337)"
                  fill="#002c54"
                />
                <path
                  id="Path_27247"
                  data-name="Path 27247"
                  d="M533.594,271.1c-9.1-1.084-5.7-9.929-4.453-11.96.331-.105,1.9-.586,2.015-.661a.051.051,0,0,1,.031-.015,2.5,2.5,0,0,0,.706-1.053c.888-2.333.482-6.98.452-7.282v-.857c.15-.556.3-1.084.421-1.579l4.784-3.761,10.123-7.959s-2.692,13.314-.526,21.708a3.162,3.162,0,0,0,1.339,2.017c0,.015.015,0,.015,0a2.453,2.453,0,0,0,1.008.36C551.992,261.227,548.532,272.871,533.594,271.1Z"
                  transform="translate(-505.862 -203.273)"
                  fill="#e5918f"
                />
                <path
                  id="Path_27248"
                  data-name="Path 27248"
                  d="M540.472,242.236s-.085,8.885-9.729,12.97c.9-2.318.483-6.97.455-7.268l4.04-3.172Z"
                  transform="translate(-504.719 -201.08)"
                  fill="#cc6362"
                />
                <path
                  id="Path_27249"
                  data-name="Path 27249"
                  d="M517.776,229.439s2.1,29.087,9.958,31.559c0,0,10.006.942,17.19-8.722,2.071-2.785,4.686-3.41,5.54-6.773,1.387-5.462,3.345-15.535.848-21.606C547.757,215.252,518.114,208.386,517.776,229.439Z"
                  transform="translate(-509.257 -210.427)"
                  fill="#e5918f"
                />
                <path
                  id="Path_27250"
                  data-name="Path 27250"
                  d="M553.641,220.419c-.128-5.284-5.477-7.257-5.477-7.257-5.324-2.492-16.388-1.417-27.8,1.127-2.674.6-6.03-1.045-7.9.251-2.257,1.566-.009,8.721-.009,8.721,4.4,13.325,20.592,8.992,25.457,7.348,1.157,3.432,1.008,8.2,3.893,10.66,1.643,1.4,4.5,1.442,7.4.958.358.679,1.7,1.278,1.974,2.211.915,3.116.784,7.985.756,11.744l1.373-.671C553.5,254.494,567.7,220.855,553.641,220.419Z"
                  transform="translate(-511.465 -211.748)"
                  fill="#002c54"
                />
                <g
                  id="Group_15769"
                  data-name="Group 15769"
                  transform="translate(9.686 23.201)"
                >
                  <path
                    id="Path_27251"
                    data-name="Path 27251"
                    d="M525.53,234.083c.41,2.415-.78,4.632-2.661,4.952s-3.737-1.378-4.148-3.793.78-4.633,2.661-4.953S525.118,231.666,525.53,234.083Z"
                    transform="translate(-518.64 -228.476)"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="0.501"
                  />
                  <path
                    id="Path_27252"
                    data-name="Path 27252"
                    d="M532.56,232.769c.412,2.415-.779,4.633-2.659,4.953s-3.738-1.378-4.148-3.795.78-4.633,2.659-4.953S532.15,230.354,532.56,232.769Z"
                    transform="translate(-516.18 -228.935)"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="0.501"
                  />
                  <path
                    id="Path_27253"
                    data-name="Path 27253"
                    d="M523.744,233.224s.416-.676,2.6-.486"
                    transform="translate(-516.854 -227.617)"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="0.501"
                  />
                  <line
                    id="Line_189"
                    data-name="Line 189"
                    y1="1.296"
                    x2="8.113"
                    transform="translate(16.462 3.117)"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="0.501"
                  />
                </g>
                <g
                  id="Group_15770"
                  data-name="Group 15770"
                  transform="translate(32.537 24.367)"
                >
                  <path
                    id="Path_27254"
                    data-name="Path 27254"
                    d="M537.887,242.047c5.587,2.14,7.331-11.611,2.026-12.221-4.023-.462-4.188,5.151-4.188,5.151S534.7,240.825,537.887,242.047Z"
                    transform="translate(-535.568 -229.799)"
                    fill="#e5918f"
                  />
                </g>
                <g
                  id="Group_15771"
                  data-name="Group 15771"
                  transform="translate(34.807 26.468)"
                  opacity="0.5"
                >
                  <path
                    id="Path_27255"
                    data-name="Path 27255"
                    d="M539.142,231.355s-3.3,1.747-1.183,7.107"
                    transform="translate(-537.25 -231.355)"
                    fill="none"
                    stroke="#cc6362"
                    strokeMiterlimit="10"
                    strokeWidth="0.724"
                  />
                  <path
                    id="Path_27256"
                    data-name="Path 27256"
                    d="M540,233.289a2.918,2.918,0,0,0-2.713,2.014"
                    transform="translate(-537.237 -230.678)"
                    fill="none"
                    stroke="#cc6362"
                    strokeMiterlimit="10"
                    strokeWidth="0.724"
                  />
                </g>
              </g>
              <path
                id="Path_27257"
                data-name="Path 27257"
                d="M584.479,321.193v.014c-2.456,2.848-11.773,4.925-16.256.984-1.41-1.255-3-4.563-4.562-8.667-3.976-10.493-7.738-26.191-7.738-26.191l20.851-10.655s2.682,12.028,4.993,23.458c0,0,.02.116.063.318.752,3.661,1.452,7.263,2,10.353a1.432,1.432,0,0,1,.04.246A43.791,43.791,0,0,1,584.479,321.193Z"
                transform="translate(-401.473 -189.027)"
                fill="#e5918f"
              />
              <path
                id="Path_27258"
                data-name="Path 27258"
                d="M550.089,279.541c2.014,8.372,8.343,24.239,8.343,24.239,4.433.736,10.377-.081,15.3-1.851a28.2,28.2,0,0,0,9.748-6.331s-4.2-11.8-7.965-20.272c-3.382-7.608-5.412-10.448-6.875-11.956a33.132,33.132,0,0,0-8.279-6.157Z"
                transform="translate(-403.514 -195.839)"
                fill="#fff"
              />
              <path
                id="Path_27259"
                data-name="Path 27259"
                d="M575.292,285.612l-12.236-5.28-9.641-24.841s1.767.537,4.094,1.477h.011c.044.022.144.055.313.123a1.268,1.268,0,0,1,.178.078c2.08.973,10.145,5.726,15.727,23l.134.436c.593,1.991,1.029,3.591,1.263,4.418.023.078.046.157.068.246C575.237,285.377,575.26,285.5,575.292,285.612Z"
                transform="translate(-402.35 -196.441)"
                fill="#fff"
              />
              <g
                id="Group_15773"
                data-name="Group 15773"
                transform="translate(104.754 110.8)"
              >
                <path
                  id="Path_27260"
                  data-name="Path 27260"
                  d="M593.7,315.193v.014c-.18,1.527-.6,2.624-1.355,3.013-.12.077-1.832,1.1-1.952,1.173a104.064,104.064,0,0,1-12.924,6.684,468.266,468.266,0,0,1-45.134,16.217,53.2,53.2,0,0,0-2.761-6.3,118.24,118.24,0,0,0,19.593-12.028c9.726-7.423,23.716-16.441,23.716-16.441l3.533-4.155s12.557-11.558,14.574-9.234c0,0,.02.116.063.319.3,1.205,1.3,5.64,2,10.353a1.432,1.432,0,0,1,.041.246A43.8,43.8,0,0,1,593.7,315.193Z"
                  transform="translate(-515.448 -293.826)"
                  fill="#e5918f"
                />
                <path
                  id="Path_27261"
                  data-name="Path 27261"
                  d="M534.678,324.986a7.768,7.768,0,0,1-4.957.953c-1.383-.29-1.942-.857-2.966-1.037a23.042,23.042,0,0,1-5.1-1.179c-1.349-.661-1.875-.736-1.828.62s2.709,2.526,3.431,2.9a6.839,6.839,0,0,1,1.725,1.728c.1.151-4.437,2.524-5.656,2.042a3.532,3.532,0,0,0-.157,1.7c.206.609,1.139.824,1.212,1.13s-.215.931-.012,1.419,1.034.487,1.37,1.277-.034.8.211,1.627,1.3.973,1.5,1.4.095.922.536,1.215,4.521-1.016,6.01-1.654,5.467-6.366,9.869-8.318Z"
                  transform="translate(-519.109 -283.525)"
                  fill="#e5918f"
                />
              </g>
              <path
                id="Path_27262"
                data-name="Path 27262"
                d="M554.3,344.282H522.585v-3.1H554.3a1.552,1.552,0,0,1,1.553,1.551h0A1.553,1.553,0,0,1,554.3,344.282Z"
                transform="translate(-413.138 -166.456)"
                fill="#375f84"
              />
              <path
                id="Path_27263"
                data-name="Path 27263"
                d="M558.719,359.716H479.3a2.116,2.116,0,0,1-2.04-1.551L461,299.649a2.033,2.033,0,0,1,1.959-2.577h76.8a3.984,3.984,0,0,1,3.838,2.919L559.8,358.3A1.12,1.12,0,0,1,558.719,359.716Z"
                transform="translate(-434.715 -181.891)"
                fill="#375f84"
              />
              <path
                id="Path_27264"
                data-name="Path 27264"
                d="M556.589,359.716h-79.42a2.119,2.119,0,0,1-2.041-1.551l-16.255-58.516a2.033,2.033,0,0,1,1.959-2.577h76.8a3.984,3.984,0,0,1,3.839,2.919l16.2,58.305A1.12,1.12,0,0,1,556.589,359.716Z"
                transform="translate(-435.46 -181.891)"
                fill="#467cdb"
              />
            </g>
          </g>
          <g
            id="Group_15776"
            data-name="Group 15776"
            transform="translate(181.436 256.419)"
          >
            <path
              id="Path_27265"
              data-name="Path 27265"
              d="M298.064,321.883l9.2-9.432s.319-4.206.819-5.093,1.8-4.173,2.439-4.53a3.332,3.332,0,0,1,1.935,0,8.855,8.855,0,0,1,1.851-.431,5.428,5.428,0,0,1,1.646.524s1.375-.093,1.948-.093a1.223,1.223,0,0,1,.757.161,40.63,40.63,0,0,1,3.293-3.411c1.075-.859,2.717-2.442,3.2-2.435.459.005.661.813.327,1.673a9.531,9.531,0,0,1-1.789,2.246l-4.192,6.351a9.015,9.015,0,0,0,1.1-.525c.382-.239,2.939-2.627,3.094-2.723s1.3-.858,1.97-.094-4.389,6.821-5.2,7.634A44.3,44.3,0,0,1,315,314.869s-4.908,8.83-5.386,9.4S298.064,321.883,298.064,321.883Z"
              transform="translate(-144.482 -257.719)"
              fill="#e49191"
            />
            <path
              id="Path_27266"
              data-name="Path 27266"
              d="M313.337,287.253s-5.139,29.769-9.976,30.46c0,0-19.311.779-23.612-22.648-3.731-20.315,11.233-24.647,18.231-23.093S314.84,274.536,313.337,287.253Z"
              transform="translate(-151.096 -266.627)"
              fill="#e49191"
            />
            <path
              id="Path_27267"
              data-name="Path 27267"
              d="M296.789,306.447s-2.705,3.646-3.653,12.479a28.668,28.668,0,0,1-15.457-2.667,109.41,109.41,0,0,0,4.486-25.986"
              transform="translate(-151.615 -260.122)"
              fill="#e49191"
            />
            <path
              id="Path_27268"
              data-name="Path 27268"
              d="M291.863,268.3c-10.552,2.331-9.709,8.906-9.709,8.906-4.939,1.223-6,3.263-5.961,12.382s3.341,20.069,5.161,20.96,12.136.934,13,.621,4.471-8.679,3.63-10.15.042-7.26,2.445-7.479,1.932,3.5,1.932,3.5l1.975-.433,1.525-3.739c13.945.83,17.548-15.061,17.548-15.061C320.055,275.625,302.417,265.967,291.863,268.3Z"
              transform="translate(-152.135 -267.938)"
              fill="#002c54"
            />
            <path
              id="Path_27269"
              data-name="Path 27269"
              d="M202.569,417.524l10.67,1.542-3.534,12.46-11.555-2.915s-4.7-6.373,2.4-11.087A3.887,3.887,0,0,1,202.569,417.524Z"
              transform="translate(-179.98 -215.64)"
              fill="#e5918f"
            />
            <path
              id="Path_27270"
              data-name="Path 27270"
              d="M279.6,406.322,263.878,358.7s-4.767-1.7-7.207,0c0,0-16.383,8.81-14.636,33.929,1.318,18.937,5.316,39.476,6.936,47.712l-41.957-1.552a14.3,14.3,0,0,0-1.828,14.162s52.723,14.18,60.149,15.489c6.036,1.066,12.642,1.887,15.832-.846C286.786,462.785,279.6,406.322,279.6,406.322Z"
              transform="translate(-177.378 -236.44)"
            />
            <path
              id="Path_27271"
              data-name="Path 27271"
              d="M239.37,417.524l10.67,1.542-3.534,12.46-11.555-2.915s-4.7-6.373,2.4-11.087A3.887,3.887,0,0,1,239.37,417.524Z"
              transform="translate(-167.102 -215.64)"
              fill="#e5918f"
            />
            <path
              id="Path_27272"
              data-name="Path 27272"
              d="M239.812,424.885c-.239,2.453,1.907,4.661,1.515,5.273s-7.565,12.645-7.565,12.645,5.415,2.358,4.541,5.764H224.59s-3.58-3.232-3.494-7.861a39.778,39.778,0,0,1,3.378-10.043c2.445-4.717,8.005-15.365,8.005-15.365a7.764,7.764,0,0,1,4.571.088,27.72,27.72,0,0,1,6.634,2.967S240.4,418.824,239.812,424.885Z"
              transform="translate(-171.416 -216.469)"
              fill="#467cdb"
            />
            <path
              id="Path_27273"
              data-name="Path 27273"
              d="M343.059,457.4c-3.386-12.633-35.24-66.564-46.017-81.126-22.134-9.61-45.725-17.765-45.725-17.765-9.756,2.33-14.562,21.989-9.028,35.094,3.8,8.992,27.879,31.621,42.627,44.943l-40.925-.049s-4.822,7.206-.452,14.05c0,0,68.065,15.477,74.036,16.35s19.368,0,19.368,0S345.908,468.035,343.059,457.4Z"
              transform="translate(-164.817 -236.244)"
              fill="#002c54"
            />
            <path
              id="Path_27274"
              data-name="Path 27274"
              d="M203.011,424.885c-.239,2.453,1.907,4.661,1.515,5.273s-7.566,12.645-7.566,12.645,5.416,2.358,4.543,5.764H187.789s-3.581-3.232-3.494-7.861a39.778,39.778,0,0,1,3.378-10.043c2.445-4.717,8.005-15.365,8.005-15.365a7.762,7.762,0,0,1,4.571.088,27.751,27.751,0,0,1,6.634,2.967S203.6,418.824,203.011,424.885Z"
              transform="translate(-184.294 -216.469)"
              fill="#467cdb"
            />
            <path
              id="Path_27275"
              data-name="Path 27275"
              d="M367.43,308.679l-21.951,38.612-15.721-15.67L316.745,350.99l3.778,1.814-1.359,1.131s30.339,14.775,33.974,11.516,20.574-52.383,20.574-52.383Z"
              transform="translate(-137.944 -253.681)"
              fill="#e49191"
            />
            <path
              id="Path_27276"
              data-name="Path 27276"
              d="M359.492,335.9s-4.144,17.482-12.433,25.77L325.851,353.6s-9.841,16.55-19.466,29.24c-3.7,4.9-4.927,11.8-9.274,12.7-.27-.095-.526-.175-.8-.243-11.785-3.537-29.172.216-43.522-5.116-15.848-5.9-12.77-9.22-12.77-9.22s9.611-17.32,15.065-35.665a218.68,218.68,0,0,0,5.238-21.5,24.761,24.761,0,0,1,20.843-19.938c.122-.013.23-.04.351-.054,12.014-1.525,43.468,2.187,49.583,4.806S359.492,335.9,359.492,335.9Z"
              transform="translate(-164.877 -255.512)"
              fill="#467cdb"
            />
            <path
              id="Path_27277"
              data-name="Path 27277"
              d="M310.99,341.328s-9.841,16.55-19.466,29.24c-3.7,4.9-4.927,11.8-9.274,12.7,1.9-.675,5.062-10.692,6.183-12.946s2.929-4.5,6.817-12.365,9.134-19.438,9.134-19.438Z"
              transform="translate(-150.015 -243.239)"
              fill="#5996ef"
            />
            <path
              id="Path_27278"
              data-name="Path 27278"
              d="M273.26,417.8a68.676,68.676,0,0,1,21.156,3.04"
              transform="translate(-153.161 -215.499)"
              fill="none"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.065"
            />
            <path
              id="Path_27279"
              data-name="Path 27279"
              d="M371.027,299.943c-.355-.036-2.6,1.77-3.691,2.662l1.251-2.4a23.585,23.585,0,0,0,2.25-2.476c.6-.877.282-1.755-.188-1.8-.331-.034-2.311,1.538-3.457,2.472l.252-.482a23.58,23.58,0,0,0,2.25-2.476c.6-.877.282-1.755-.188-1.8s-4.278,3.149-4.278,3.149l-1.855,2.483,1.4-2.715A11.7,11.7,0,0,0,366,294.678c.49-.981.136-1.282-.136-1.609s-2.836,1.582-3.491,2.345a39.6,39.6,0,0,0-2.89,4.3l-2.142,4.432c-.138-1.284-.352-3.482-.5-4.881-.219-2.018-2.045-2.5-2.109-1.515s-1.081,5.809-.85,8.426.668,4.336.832,5.809-1.363,4.416-1.363,4.416,6.108,3.793,7.12,2.658a47.7,47.7,0,0,0,4.2-5.355,28.518,28.518,0,0,0,2.391-5.4l1.909-4.078a23.592,23.592,0,0,0,2.25-2.476C371.81,300.866,371.5,299.988,371.027,299.943Z"
              transform="translate(-125.136 -259.157)"
              fill="#e49191"
            />
          </g>
          <g
            id="Group_15778"
            data-name="Group 15778"
            transform="translate(698.024 174.256)"
          >
            <path
              id="Path_27280"
              data-name="Path 27280"
              d="M646.916,207.074H575.283a8.313,8.313,0,0,0-8.313,8.313v16.921a8.316,8.316,0,0,0,7.264,8.248,1.2,1.2,0,0,1,1.049,1.189v9.265a.551.551,0,0,0,1,.32l7.3-10.2a1.208,1.208,0,0,1,.983-.506h62.355a8.313,8.313,0,0,0,8.313-8.313V215.387A8.313,8.313,0,0,0,646.916,207.074Z"
              transform="translate(-566.97 -207.074)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="0.896"
            />
            <g
              id="Group_15777"
              data-name="Group 15777"
              transform="translate(13.829 14.011)"
            >
              <path
                id="Path_27281"
                data-name="Path 27281"
                d="M582.688,220.191a2.737,2.737,0,1,1-2.738-2.738A2.736,2.736,0,0,1,582.688,220.191Z"
                transform="translate(-577.214 -217.453)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27282"
                data-name="Path 27282"
                d="M592.9,220.191a2.737,2.737,0,1,1-2.736-2.738A2.736,2.736,0,0,1,592.9,220.191Z"
                transform="translate(-573.642 -217.453)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27283"
                data-name="Path 27283"
                d="M603.106,220.191a2.736,2.736,0,1,1-2.736-2.738A2.735,2.735,0,0,1,603.106,220.191Z"
                transform="translate(-570.069 -217.453)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27284"
                data-name="Path 27284"
                d="M613.316,220.191a2.737,2.737,0,1,1-2.738-2.738A2.737,2.737,0,0,1,613.316,220.191Z"
                transform="translate(-566.496 -217.453)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27285"
                data-name="Path 27285"
                d="M623.525,220.191a2.737,2.737,0,1,1-2.736-2.738A2.735,2.735,0,0,1,623.525,220.191Z"
                transform="translate(-562.924 -217.453)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
            </g>
          </g>
          <g
            id="Group_15780"
            data-name="Group 15780"
            transform="translate(203.628 248.444)"
          >
            <path
              id="Path_27286"
              data-name="Path 27286"
              d="M209.046,262.031h71.633a8.311,8.311,0,0,1,8.312,8.311v16.923a8.313,8.313,0,0,1-7.263,8.247,1.2,1.2,0,0,0-1.049,1.191v9.263a.551.551,0,0,1-1,.32l-7.3-10.2a1.207,1.207,0,0,0-.983-.5H209.046a8.313,8.313,0,0,1-8.313-8.313V270.343A8.312,8.312,0,0,1,209.046,262.031Z"
              transform="translate(-200.733 -262.031)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="0.896"
            />
            <g
              id="Group_15779"
              data-name="Group 15779"
              transform="translate(13.829 14.011)"
            >
              <path
                id="Path_27287"
                data-name="Path 27287"
                d="M251.814,275.148a2.737,2.737,0,1,0,2.738-2.738A2.737,2.737,0,0,0,251.814,275.148Z"
                transform="translate(-196.687 -272.41)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27288"
                data-name="Path 27288"
                d="M241.605,275.148a2.737,2.737,0,1,0,2.736-2.738A2.737,2.737,0,0,0,241.605,275.148Z"
                transform="translate(-200.259 -272.41)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27289"
                data-name="Path 27289"
                d="M231.4,275.148a2.737,2.737,0,1,0,2.738-2.738A2.737,2.737,0,0,0,231.4,275.148Z"
                transform="translate(-203.832 -272.41)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27290"
                data-name="Path 27290"
                d="M221.186,275.148a2.737,2.737,0,1,0,2.736-2.738A2.737,2.737,0,0,0,221.186,275.148Z"
                transform="translate(-207.405 -272.41)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <path
                id="Path_27291"
                data-name="Path 27291"
                d="M210.977,275.148a2.737,2.737,0,1,0,2.736-2.738A2.736,2.736,0,0,0,210.977,275.148Z"
                transform="translate(-210.977 -272.41)"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
            </g>
          </g>
          <g
            id="Group_15782"
            data-name="Group 15782"
            transform="translate(500.953 109.141)"
          >
            <path
              id="Path_27292"
              data-name="Path 27292"
              d="M564.582,184.913H434.022a13.038,13.038,0,0,1-13.038-13.038h0a13.038,13.038,0,0,1,13.038-13.038h130.56a13.038,13.038,0,0,1,13.038,13.038h0A13.038,13.038,0,0,1,564.582,184.913Z"
              transform="translate(-420.984 -158.838)"
              fill="#fff"
              stroke="#495ad6"
              strokeMiterlimit="10"
              strokeWidth="0.896"
            />
            <g
              id="Group_15781"
              data-name="Group 15781"
              transform="translate(127.819 5.205)"
            >
              <path
                id="Path_27293"
                data-name="Path 27293"
                d="M529.536,169.629a6.933,6.933,0,1,1-6.933-6.935A6.933,6.933,0,0,1,529.536,169.629Z"
                transform="translate(-515.669 -162.694)"
                fill="none"
                stroke="#495ad6"
                strokeMiterlimit="10"
                strokeWidth="1.672"
              />
              <line
                id="Line_190"
                data-name="Line 190"
                x2="3.828"
                y2="3.828"
                transform="translate(11.835 11.836)"
                fill="none"
                stroke="#495ad6"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.672"
              />
            </g>
          </g>
          <g
            id="Group_15805"
            data-name="Group 15805"
            transform="translate(115.087 146.091)"
          >
            <g
              id="Group_15783"
              data-name="Group 15783"
              transform="translate(278.659 290.063)"
            >
              <rect
                id="Rectangle_6138"
                data-name="Rectangle 6138"
                width="53.656"
                height="53.656"
                rx="7.708"
                transform="translate(9.778)"
                fill="#193091"
              />
              <rect
                id="Rectangle_6139"
                data-name="Rectangle 6139"
                width="53.656"
                height="53.656"
                rx="7.708"
                transform="translate(0)"
                fill="#495ad6"
              />
              <path
                id="Path_27294"
                data-name="Path 27294"
                d="M357.3,413.5l15.4,8.892a1.427,1.427,0,0,1,0,2.47l-15.4,8.892a1.425,1.425,0,0,1-2.138-1.235V414.738A1.426,1.426,0,0,1,357.3,413.5Z"
                transform="translate(-336.811 -396.802)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_15784"
              data-name="Group 15784"
              transform="translate(602.124 273.578)"
            >
              <rect
                id="Rectangle_6140"
                data-name="Rectangle 6140"
                width="70.141"
                height="70.141"
                rx="10.076"
                transform="translate(12.783)"
                fill="#193091"
              />
              <rect
                id="Rectangle_6141"
                data-name="Rectangle 6141"
                width="70.141"
                height="70.141"
                rx="10.076"
                fill="#495ad6"
              />
              <path
                id="Path_27295"
                data-name="Path 27295"
                d="M617.774,403.8a8.427,8.427,0,1,1-8.428-8.428A8.428,8.428,0,0,1,617.774,403.8Z"
                transform="translate(-574.276 -386.593)"
                fill="#fff"
              />
              <path
                id="Path_27296"
                data-name="Path 27296"
                d="M629.284,427.308v12.441a2.036,2.036,0,0,1-2.034,2.036H596.184a2.036,2.036,0,0,1-2.036-2.036V427.308a17.568,17.568,0,0,1,17.568-17.567h0A17.567,17.567,0,0,1,629.284,427.308Z"
                transform="translate(-576.646 -381.566)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_15785"
              data-name="Group 15785"
              transform="translate(450.686)"
            >
              <path
                id="Path_27297"
                data-name="Path 27297"
                d="M498.651,190.354H471.073A2.073,2.073,0,0,1,469,188.282h0a2.073,2.073,0,0,1,2.072-2.072h27.578a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,498.651,190.354Z"
                transform="translate(-469.001 -186.21)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27298"
                data-name="Path 27298"
                d="M517.113,190.354H497.155a2.073,2.073,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.072h19.957a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,517.113,190.354Z"
                transform="translate(-459.874 -186.21)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27299"
                data-name="Path 27299"
                d="M482.791,197.1H471.073A2.073,2.073,0,0,1,469,195.032h0a2.073,2.073,0,0,1,2.072-2.072h11.717a2.073,2.073,0,0,1,2.072,2.072h0A2.073,2.073,0,0,1,482.791,197.1Z"
                transform="translate(-469.001 -183.848)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27300"
                data-name="Path 27300"
                d="M521.4,197.1H484.905a2.073,2.073,0,0,1-2.072-2.072h0a2.073,2.073,0,0,1,2.072-2.072H521.4a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,521.4,197.1Z"
                transform="translate(-464.161 -183.848)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27301"
                data-name="Path 27301"
                d="M507.426,203.854H471.073A2.073,2.073,0,0,1,469,201.782h0a2.073,2.073,0,0,1,2.072-2.072h36.352a2.072,2.072,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,507.426,203.854Z"
                transform="translate(-469.001 -181.486)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27302"
                data-name="Path 27302"
                d="M514.977,203.854H503.261a2.073,2.073,0,0,1-2.074-2.072h0a2.074,2.074,0,0,1,2.074-2.072h11.716a2.073,2.073,0,0,1,2.072,2.072h0A2.072,2.072,0,0,1,514.977,203.854Z"
                transform="translate(-457.738 -181.486)"
                fill="#f0f4ff"
              />
            </g>
            <g
              id="Group_15789"
              data-name="Group 15789"
              transform="translate(29.695 156.885)"
            >
              <rect
                id="Rectangle_6142"
                data-name="Rectangle 6142"
                width="106.593"
                height="58.92"
                rx="3.823"
                fill="#193091"
              />
              <line
                id="Line_191"
                data-name="Line 191"
                x2="97.533"
                transform="translate(4.53 7.96)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="0.896"
              />
              <circle
                id="Ellipse_1555"
                data-name="Ellipse 1555"
                cx="1.181"
                cy="1.181"
                r="1.181"
                transform="translate(98.307 2.729)"
                fill="#fff"
              />
              <circle
                id="Ellipse_1556"
                data-name="Ellipse 1556"
                cx="1.181"
                cy="1.181"
                r="1.181"
                transform="translate(92.148 2.729)"
                fill="#fff"
              />
              <circle
                id="Ellipse_1557"
                data-name="Ellipse 1557"
                cx="1.181"
                cy="1.181"
                r="1.181"
                transform="translate(85.989 2.729)"
                fill="#fff"
              />
              <g
                id="Group_15788"
                data-name="Group 15788"
                transform="translate(4.531 12.628)"
              >
                <g id="Group_15786" data-name="Group 15786">
                  <path
                    id="Path_27303"
                    data-name="Path 27303"
                    d="M178.678,315.044h-16.55a1.631,1.631,0,0,1-1.631-1.631h0a1.632,1.632,0,0,1,1.631-1.632h16.55a1.632,1.632,0,0,1,1.631,1.632h0A1.631,1.631,0,0,1,178.678,315.044Z"
                    transform="translate(-160.497 -311.781)"
                    fill="#6589d1"
                  />
                  <path
                    id="Path_27304"
                    data-name="Path 27304"
                    d="M178.678,320.627h-16.55A1.631,1.631,0,0,1,160.5,319h0a1.631,1.631,0,0,1,1.631-1.631h16.55A1.631,1.631,0,0,1,180.309,319h0A1.631,1.631,0,0,1,178.678,320.627Z"
                    transform="translate(-160.497 -309.827)"
                    fill="#6589d1"
                  />
                  <path
                    id="Path_27305"
                    data-name="Path 27305"
                    d="M178.678,326.211h-16.55a1.631,1.631,0,0,1-1.631-1.632h0a1.631,1.631,0,0,1,1.631-1.631h16.55a1.631,1.631,0,0,1,1.631,1.631h0A1.631,1.631,0,0,1,178.678,326.211Z"
                    transform="translate(-160.497 -307.873)"
                    fill="#6589d1"
                  />
                  <path
                    id="Path_27306"
                    data-name="Path 27306"
                    d="M178.678,331.794h-16.55a1.631,1.631,0,0,1-1.631-1.631h0a1.632,1.632,0,0,1,1.631-1.632h16.55a1.632,1.632,0,0,1,1.631,1.632h0A1.631,1.631,0,0,1,178.678,331.794Z"
                    transform="translate(-160.497 -305.92)"
                    fill="#6589d1"
                  />
                  <path
                    id="Path_27307"
                    data-name="Path 27307"
                    d="M178.678,337.377h-16.55a1.631,1.631,0,0,1-1.631-1.631h0a1.631,1.631,0,0,1,1.631-1.631h16.55a1.631,1.631,0,0,1,1.631,1.631h0A1.631,1.631,0,0,1,178.678,337.377Z"
                    transform="translate(-160.497 -303.966)"
                    fill="#6589d1"
                  />
                  <path
                    id="Path_27308"
                    data-name="Path 27308"
                    d="M178.678,342.961h-16.55a1.631,1.631,0,0,1-1.631-1.632h0a1.631,1.631,0,0,1,1.631-1.631h16.55a1.631,1.631,0,0,1,1.631,1.631h0A1.631,1.631,0,0,1,178.678,342.961Z"
                    transform="translate(-160.497 -302.012)"
                    fill="#6589d1"
                  />
                </g>
                <g
                  id="Group_15787"
                  data-name="Group 15787"
                  transform="translate(22.949)"
                >
                  <path
                    id="Path_27309"
                    data-name="Path 27309"
                    d="M250.449,315.044H179.128a1.631,1.631,0,0,1-1.631-1.631h0a1.632,1.632,0,0,1,1.631-1.632h71.321a1.632,1.632,0,0,1,1.632,1.632h0A1.631,1.631,0,0,1,250.449,315.044Z"
                    transform="translate(-177.497 -311.781)"
                    fill="#3b5fb7"
                  />
                  <path
                    id="Path_27310"
                    data-name="Path 27310"
                    d="M250.449,320.627H179.128A1.631,1.631,0,0,1,177.5,319h0a1.631,1.631,0,0,1,1.631-1.631h71.321A1.631,1.631,0,0,1,252.081,319h0A1.631,1.631,0,0,1,250.449,320.627Z"
                    transform="translate(-177.497 -309.827)"
                    fill="#3b5fb7"
                  />
                  <path
                    id="Path_27311"
                    data-name="Path 27311"
                    d="M250.449,326.211H179.128a1.631,1.631,0,0,1-1.631-1.632h0a1.631,1.631,0,0,1,1.631-1.631h71.321a1.631,1.631,0,0,1,1.632,1.631h0A1.632,1.632,0,0,1,250.449,326.211Z"
                    transform="translate(-177.497 -307.873)"
                    fill="#3b5fb7"
                  />
                  <path
                    id="Path_27312"
                    data-name="Path 27312"
                    d="M250.449,331.794H179.128a1.631,1.631,0,0,1-1.631-1.631h0a1.632,1.632,0,0,1,1.631-1.632h71.321a1.632,1.632,0,0,1,1.632,1.632h0A1.631,1.631,0,0,1,250.449,331.794Z"
                    transform="translate(-177.497 -305.92)"
                    fill="#3b5fb7"
                  />
                  <path
                    id="Path_27313"
                    data-name="Path 27313"
                    d="M250.449,337.377H179.128a1.631,1.631,0,0,1-1.631-1.631h0a1.631,1.631,0,0,1,1.631-1.631h71.321a1.631,1.631,0,0,1,1.632,1.631h0A1.631,1.631,0,0,1,250.449,337.377Z"
                    transform="translate(-177.497 -303.966)"
                    fill="#3b5fb7"
                  />
                  <path
                    id="Path_27314"
                    data-name="Path 27314"
                    d="M250.449,342.961H179.128a1.631,1.631,0,0,1-1.631-1.632h0a1.631,1.631,0,0,1,1.631-1.631h71.321a1.631,1.631,0,0,1,1.632,1.631h0A1.632,1.632,0,0,1,250.449,342.961Z"
                    transform="translate(-177.497 -302.012)"
                    fill="#3b5fb7"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_15796"
              data-name="Group 15796"
              transform="translate(0 38.182)"
            >
              <rect
                id="Rectangle_6143"
                data-name="Rectangle 6143"
                width="74.022"
                height="74.021"
                rx="9.569"
                transform="translate(5.737 6.412)"
                fill="#193091"
              />
              <rect
                id="Rectangle_6144"
                data-name="Rectangle 6144"
                width="74.022"
                height="74.021"
                rx="7.667"
                fill="#7e89fd"
                stroke="#dee3fc"
                strokeMiterlimit="10"
                strokeWidth="1"
              />
              <g
                id="Group_15795"
                data-name="Group 15795"
                transform="translate(20.575 11.672)"
              >
                <g id="Group_15794" data-name="Group 15794">
                  <path
                    id="Path_27318"
                    data-name="Path 27318"
                    d="M179.638,240h-.386v-4.24a12.621,12.621,0,1,0-25.241,0V240h-.085a3.54,3.54,0,0,0-3.541,3.541v15.979a3.541,3.541,0,0,0,3.541,3.542h25.712a3.543,3.543,0,0,0,3.542-3.542V243.545A3.541,3.541,0,0,0,179.638,240Zm-22.431-4.24a9.424,9.424,0,1,1,18.848,0V240H157.208Z"
                    transform="translate(-150.385 -223.141)"
                    fill="#dee3fc"
                  />
                  <path
                    id="Path_27319"
                    data-name="Path 27319"
                    d="M167.746,242.784a4.119,4.119,0,1,0-6.195,3.55.738.738,0,0,1,.374.826l-.717,2.646a2.473,2.473,0,1,0,4.775,0l-.709-2.618a.74.74,0,0,1,.383-.833A4.1,4.1,0,0,0,167.746,242.784Z"
                    transform="translate(-147.192 -217.708)"
                    fill="#7e89fd"
                  />
                </g>
                <path
                  id="Path_27320"
                  data-name="Path 27320"
                  d="M181.662,257.655H151.9a1.517,1.517,0,0,1-1.519-1.519h0a1.518,1.518,0,0,1,1.519-1.519h29.758a1.519,1.519,0,0,1,1.519,1.519h0A1.518,1.518,0,0,1,181.662,257.655Z"
                  transform="translate(-150.385 -212.126)"
                  fill="#dee3fc"
                />
                <path
                  id="Path_27321"
                  data-name="Path 27321"
                  d="M181.662,261.468H151.9a1.518,1.518,0,0,1-1.519-1.519h0a1.517,1.517,0,0,1,1.519-1.519h29.758a1.518,1.518,0,0,1,1.519,1.519h0A1.519,1.519,0,0,1,181.662,261.468Z"
                  transform="translate(-150.385 -210.792)"
                  fill="#dee3fc"
                />
              </g>
            </g>
            <g
              id="Group_15803"
              data-name="Group 15803"
              transform="translate(610.548 158.272)"
            >
              <g id="Group_15797" data-name="Group 15797">
                <path
                  id="Rectangle_6145"
                  data-name="Rectangle 6145"
                  d="M5.634,0h32.31a5.634,5.634,0,0,1,5.634,5.634V37.944a5.633,5.633,0,0,1-5.633,5.633H5.634A5.634,5.634,0,0,1,0,37.944V5.634A5.634,5.634,0,0,1,5.634,0Z"
                  transform="translate(3.377 3.775)"
                  fill="#193091"
                />
                <rect
                  id="Rectangle_6146"
                  data-name="Rectangle 6146"
                  width="43.578"
                  height="43.578"
                  rx="4.513"
                  fill="#7e89fd"
                  stroke="#dee3fc"
                  strokeMiterlimit="10"
                  strokeWidth="1"
                />
              </g>
              <g
                id="Group_15802"
                data-name="Group 15802"
                transform="translate(8.774 8.773)"
              >
                <g
                  id="Group_15798"
                  data-name="Group 15798"
                  transform="translate(2.859)"
                >
                  <path
                    id="Path_27322"
                    data-name="Path 27322"
                    d="M597.392,335.983a1.285,1.285,0,0,1-.368-.051,1.347,1.347,0,0,1-.931-1.664l6.59-23.328a1.349,1.349,0,1,1,2.6.733L598.69,335A1.349,1.349,0,0,1,597.392,335.983Z"
                    transform="translate(-596.041 -309.953)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_15799"
                  data-name="Group 15799"
                  transform="translate(13.879)"
                >
                  <path
                    id="Path_27323"
                    data-name="Path 27323"
                    d="M605.555,335.983a1.27,1.27,0,0,1-.367-.051,1.347,1.347,0,0,1-.933-1.664l6.592-23.328a1.349,1.349,0,1,1,2.6.733L606.853,335A1.348,1.348,0,0,1,605.555,335.983Z"
                    transform="translate(-604.204 -309.953)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_15800"
                  data-name="Group 15800"
                  transform="translate(0 6.38)"
                >
                  <path
                    id="Path_27324"
                    data-name="Path 27324"
                    d="M618.6,317.379H595.273a1.35,1.35,0,1,1,0-2.7H618.6a1.35,1.35,0,0,1,0,2.7Z"
                    transform="translate(-593.923 -314.679)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_15801"
                  data-name="Group 15801"
                  transform="translate(0 17.036)"
                >
                  <path
                    id="Path_27325"
                    data-name="Path 27325"
                    d="M618.6,325.273H595.273a1.35,1.35,0,1,1,0-2.7H618.6a1.35,1.35,0,0,1,0,2.7Z"
                    transform="translate(-593.923 -322.573)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_15804"
              data-name="Group 15804"
              transform="translate(105.106 63.501)"
            >
              <path
                id="Path_27326"
                data-name="Path 27326"
                d="M231.726,236.95H214.855A1.851,1.851,0,0,1,213,235.1h0a1.851,1.851,0,0,1,1.851-1.849h16.872a1.85,1.85,0,0,1,1.849,1.849h0A1.85,1.85,0,0,1,231.726,236.95Z"
                transform="translate(-213.004 -233.25)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27327"
                data-name="Path 27327"
                d="M248.722,243.033H214.855A1.85,1.85,0,0,1,213,241.184h0a1.851,1.851,0,0,1,1.851-1.851h33.867a1.85,1.85,0,0,1,1.849,1.851h0A1.849,1.849,0,0,1,248.722,243.033Z"
                transform="translate(-213.004 -231.121)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27328"
                data-name="Path 27328"
                d="M218.855,249.117h-4A1.851,1.851,0,0,1,213,247.266h0a1.85,1.85,0,0,1,1.851-1.849h4a1.849,1.849,0,0,1,1.849,1.849h0A1.85,1.85,0,0,1,218.855,249.117Z"
                transform="translate(-213.004 -228.992)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27329"
                data-name="Path 27329"
                d="M246.055,249.117H222.473a1.85,1.85,0,0,1-1.849-1.851h0a1.849,1.849,0,0,1,1.849-1.849h23.582a1.849,1.849,0,0,1,1.849,1.849h0A1.85,1.85,0,0,1,246.055,249.117Z"
                transform="translate(-210.337 -228.992)"
                fill="#f0f4ff"
              />
              <path
                id="Path_27330"
                data-name="Path 27330"
                d="M242.594,236.95H232.366a1.851,1.851,0,0,1-1.849-1.851h0a1.85,1.85,0,0,1,1.849-1.849h10.227a1.85,1.85,0,0,1,1.849,1.849h0A1.85,1.85,0,0,1,242.594,236.95Z"
                transform="translate(-206.876 -233.25)"
                fill="#f0f4ff"
              />
            </g>
            <path
              id="Path_27331"
              data-name="Path 27331"
              d="M180,425.39a11.715,11.715,0,0,0-6.015,1.652,12.616,12.616,0,0,0-25.076,2.8,9.733,9.733,0,0,0-1.786-.167,9.634,9.634,0,1,0,0,19.269H180a11.778,11.778,0,1,0,0-23.556Z"
              transform="translate(-134.322 -105.852)"
              fill="#fff"
            />
          </g>
          <line
            id="Line_204"
            data-name="Line 204"
            y1="0.713"
            x2="772.5"
            transform="translate(105.254 489.182)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.114"
          />
        </g>
        <g
          id="Group_15812"
          data-name="Group 15812"
          transform="translate(1161.73 159.72)"
        >
          <g
            id="Group_15811"
            data-name="Group 15811"
            transform="translate(0 0)"
          >
            <g
              id="Group_15810"
              data-name="Group 15810"
              clipPath="url(#clip-path)"
            >
              <path
                id="Path_27337"
                data-name="Path 27337"
                d="M884.985,340.288a3.449,3.449,0,0,0-6.193-3.039l-3.479,7.091a21.02,21.02,0,0,0-19.723,0l-3.479-7.091a3.449,3.449,0,1,0-6.193,3.038l4.1,8.348a20.979,20.979,0,0,0-5.624,14.31,1.1,1.1,0,0,0,1.1,1.1h39.919a1.1,1.1,0,0,0,1.1-1.1,20.981,20.981,0,0,0-5.623-14.31Zm-4.216-2.069a1.247,1.247,0,0,1,2.239,1.1l-3.782,7.708a21.07,21.07,0,0,0-2.02-1.548Zm-32.3-.57a1.247,1.247,0,0,1,1.668.57l3.562,7.259a21.159,21.159,0,0,0-2.02,1.549l-3.782-7.708a1.248,1.248,0,0,1,.571-1.669Zm-1.841,24.195a18.859,18.859,0,0,1,37.654,0Zm0,0"
                transform="translate(-831.403 -335.262)"
                fill="#a2abfc"
              />
            </g>
          </g>
          <path
            id="Path_27338"
            data-name="Path 27338"
            d="M1094.851,506.933a5.216,5.216,0,0,0-5.21,5.21v17.611a5.21,5.21,0,1,0,10.42,0V512.143a5.216,5.216,0,0,0-5.21-5.21Zm3.009,22.821a3.009,3.009,0,1,1-6.018,0V512.143a3.009,3.009,0,1,1,6.018,0Zm0,0"
            transform="translate(-1032.037 -475.655)"
            fill="#a2abfc"
          />
          <path
            id="Path_27339"
            data-name="Path 27339"
            d="M885.415,506.933h-5.724a1.1,1.1,0,1,0,0,2.2h4.623v25.978h-4.77a1.1,1.1,0,0,0-1.1,1.1v8.806a3.009,3.009,0,1,1-6.018,0v-8.806a1.1,1.1,0,0,0-1.1-1.1H859.585a1.1,1.1,0,0,0-1.1,1.1v8.806a3.009,3.009,0,1,1-6.018,0v-8.806a1.1,1.1,0,0,0-1.1-1.1H846.6V509.134h27.738a1.1,1.1,0,1,0,0-2.2H845.5a1.1,1.1,0,0,0-1.1,1.1v28.178a1.1,1.1,0,0,0,1.1,1.1h4.77v7.705a5.21,5.21,0,1,0,10.42,0v-7.705h9.54v7.705a5.21,5.21,0,1,0,10.42,0v-7.705h4.77a1.1,1.1,0,0,0,1.1-1.1V508.034a1.1,1.1,0,0,0-1.1-1.1Zm0,0"
            transform="translate(-831.407 -475.655)"
            fill="#a2abfc"
          />
          <path
            id="Path_27340"
            data-name="Path 27340"
            d="M778.609,506.933a5.216,5.216,0,0,0-5.21,5.21v17.611a5.21,5.21,0,1,0,10.421,0V512.143a5.216,5.216,0,0,0-5.21-5.21Zm3.009,22.821a3.009,3.009,0,1,1-6.017,0V512.143a3.009,3.009,0,1,1,6.017,0Zm0,0"
            transform="translate(-773.326 -475.655)"
            fill="#a2abfc"
          />
          <path
            id="Path_27341"
            data-name="Path 27341"
            d="M893.019,429.484a3.449,3.449,0,1,0,3.449,3.449,3.453,3.453,0,0,0-3.449-3.449Zm0,4.7a1.247,1.247,0,1,1,1.247-1.247,1.248,1.248,0,0,1-1.247,1.247Zm0,0"
            transform="translate(-868.363 -412.295)"
            fill="#a2abfc"
          />
          <path
            id="Path_27342"
            data-name="Path 27342"
            d="M996.281,429.484a3.449,3.449,0,1,0,3.449,3.449,3.453,3.453,0,0,0-3.449-3.449Zm0,4.7a1.247,1.247,0,1,1,1.248-1.247,1.248,1.248,0,0,1-1.248,1.247Zm0,0"
            transform="translate(-952.84 -412.295)"
            fill="#a2abfc"
          />
        </g>
        <g
          id="Group_15813"
          data-name="Group 15813"
          transform="translate(806.179 276.852)"
        >
          <path
            id="Path_27343"
            data-name="Path 27343"
            d="M62.038,165.988c-4.165,0-7.243-4.45-9.293-7.413-4.981-7.2-8.631-20.167-3.566-28.958A14.568,14.568,0,0,1,59.357,122.4a.839.839,0,0,1,.277,1.656,12.9,12.9,0,0,0-9,6.4c-4.739,8.224-1.1,20.525,3.492,27.165,2.484,3.591,4.971,6.8,8.071,6.686,3.293-.13,4.708-2.281,9.156-2.281s5.7,2.271,9.177,2.213,5.79-3.473,7.846-6.479a30.181,30.181,0,0,0,3.519-7,13.081,13.081,0,0,1-7.071-9.356.839.839,0,0,1,1.653-.291,11.412,11.412,0,0,0,6.184,8.153,1.671,1.671,0,0,1,.824,2.03,31.9,31.9,0,0,1-3.724,7.408c-2.171,3.175-4.875,7.128-9.2,7.21-3.972.074-5.162-2.213-9.208-2.213C67.2,163.7,65.792,165.988,62.038,165.988Z"
            transform="translate(-46.745 -108.696)"
            fill="#a2abfc"
          />
          <path
            id="Path_27344"
            data-name="Path 27344"
            d="M249.709,14.451a1.661,1.661,0,0,1-1.653-1.595c-.207-5.536,4.509-11.84,11.032-12.837a1.667,1.667,0,0,1,1.922,1.6c.133,6.313-5.151,12.655-11.254,12.827Zm9.624-12.772a12.031,12.031,0,0,0-6.782,3.845,11.219,11.219,0,0,0-2.818,7.247C254.948,12.605,259.433,7.018,259.332,1.679Z"
            transform="translate(-225.524 0)"
            fill="#a2abfc"
          />
          <path
            id="Path_27345"
            data-name="Path 27345"
            d="M211.176,135.441a.859.859,0,0,1-.11-.007.84.84,0,0,1-.723-.941,13.539,13.539,0,0,1,5.551-9,12.178,12.178,0,0,0-9.068-4.483c-4.388-.325-8.136,2.563-10.583,2.563-2.036,0-4.578-1.67-7.378-2.24a.839.839,0,1,1,.334-1.645c2.861.582,5.507,2.206,7.043,2.206,1.877,0,5.941-2.911,10.708-2.558a13.836,13.836,0,0,1,10.276,5.136,1.666,1.666,0,0,1-.345,2.378,11.851,11.851,0,0,0-4.874,7.864A.84.84,0,0,1,211.176,135.441Z"
            transform="translate(-172.365 -105.953)"
            fill="#a2abfc"
          />
        </g>
      </g>
    </svg>
  );
};

export default AppDevelopImg;
